import eventBus from 'vue-option-events';
import * as HANDLERS from '@/helpers/types/handlers';
import { Encrypt } from '@/helpers/utils';
import Lookup from '@/helpers/page/library/Lookup';
import { sleep } from '@/helpers/page';

const getGroupIndex = (groups, field) => {
  let result;

  groups.filter((item, index) => item.fields.find(x => x.model === field && (result = index)));

  return result;
};

const setReadonly = async fields =>
  fields.forEach(field => {
    if (field.type === 'i4proGroupButtons') {
      field.items.forEach(f => {
        if (f.hiddenByPage) f.readonly = true;
      });
    } else field.readonly = true;
  });

const masterReadonly = (state, { page, mode }) => {
  if (state.schemes[page][mode].master && !state.schemes[page][mode].master.readOnlyExtendTabs) return false;

  if (state.models[page].master) {
    if (state.models[page].master.fl_readonly && state.schemes[page][mode].master.readOnlyExtendTabs) return true;
  }

  if (state.parents[page]) if (state.models[state.parents[page]].master && state.models[state.parents[page]].master.fl_readonly) return true;
};

const setReadonlyFields = async (state, { page, mode, tab, step, readonlyFields }) => {
  if ((state.models[page][mode] && state.models[page][mode].fl_readonly) || masterReadonly(state, { page, mode, tab })) {
    if (tab) {
      await setReadonly(state.schemes[page][mode].tabs.content[tab].fields);
      state.schemes[page][mode].tabs.content[tab].groups.forEach(group => setReadonly(group.fields));
    } else if (step) {
      await setReadonly(state.schemes[page][mode].steps.content[step].fields);
      state.schemes[page][mode].steps.content[step].groups.forEach(group => setReadonly(group.fields));
    } else {
      state.schemes[page][mode].groups.forEach(group => setReadonly(group.fields));
      await setReadonly(state.schemes[page][mode].fields);
    }
  } else {
    if (tab) {
      state.schemes[page][mode].tabs.content[tab].fields.forEach((field, i) => {
        if (!readonlyFields.includes(field.model)) {
          field.readonly = JSON.parse(JSON.stringify(state.initialSchemes[page][mode].tabs.content[tab].fields[i].readonly));
        }
      });
      state.schemes[page][mode].tabs.content[tab].groups.forEach((group, ig) => {
        group.fields.forEach((field, i) => {
          if (!readonlyFields.includes(field.model)) {
            field.readonly = JSON.parse(JSON.stringify(state.initialSchemes[page][mode].tabs.content[tab].groups[ig].fields[i].readonly));
          }
        });
      });
    } else if (step) {
      state.schemes[page][mode].steps.content[step].fields.forEach((field, i) => {
        if (!readonlyFields.includes(field.model)) {
          field.readonly = JSON.parse(JSON.stringify(state.initialSchemes[page][mode].steps.content[step].fields[i].readonly));
        }
      });
      state.schemes[page][mode].steps.content[step].groups.forEach((group, ig) => {
        group.fields.forEach((field, i) => {
          if (!readonlyFields.includes(field.model)) {
            field.readonly = JSON.parse(JSON.stringify(state.initialSchemes[page][mode].steps.content[step].groups[ig].fields[i].readonly));
          }
        });
      });
    } else {
      state.schemes[page][mode].fields.forEach((field, i) => {
        if (!readonlyFields.includes(field.model)) {
          field.readonly = JSON.parse(JSON.stringify(state.initialSchemes[page][mode].fields[i].readonly));
        }
      });
      state.schemes[page][mode].groups.forEach((group, ig) => {
        group.fields.forEach((field, i) => {
          if (!readonlyFields.includes(field.model)) {
            field.readonly = JSON.parse(JSON.stringify(state.initialSchemes[page][mode].groups[ig].fields[i].readonly));
          }
        });
      });
    }
  }
};

const conditionsList = (state, { page, mode, items }) => {
  let fieldsInConditions = [];
  let executeConditions;
  fieldsInConditions = state.schemes[page][mode].conditions.reduce(
    (result, item) => (result = [...result, ...item.fields.map(field => field.field)]),
    []
  );
  fieldsInConditions.forEach(field => {
    executeConditions = items.reduce((allAffected, item) => {
      if (item[field] !== items[0][field]) allAffected = false;
      return allAffected;
    }, true);
  });

  if (!!state.schemes[page].list.actions && Object.keys(state.schemes[page].list.actions).length) {
    for (let field of state.schemes[page].list.actions.items) field.visible = true;
  }

  if (!executeConditions) return;

  let hideActions = [];

  state.schemes[page][mode].conditions.forEach(condition => {
    condition.fields.forEach(item => {
      if (handleCheckConditions(items[0][item.field], item.operator, item.value)) {
        hideActions = [...hideActions, ...condition.hide.actions];
      }
    });
  });
  hideActions.forEach(action => {
    let btn = state.schemes[page].list.actions.items.find(x => x.name === action);
    btn.visible = false;
  });
};

const changeTabStatus = (tab, condition, tabs) => {
  condition.action.forEach(element => {
    let prop = Object.keys(element)[0] === 'disable' ? 'readonly' : 'show';
    let tabIndex = Object.values(element)[0] - 1;

    if (tabIndex + 1 === tab) return;

    tabs[tabIndex][prop] = prop === 'readonly' ? true : false;
  });
};

const changeStepStatus = (step, condition, steps) => {
  condition.action.forEach(element => {
    let prop = Object.keys(element)[0] === 'disable' ? 'readonly' : 'show';
    let stepIndex = Object.values(element)[0] - 1;

    steps[stepIndex][prop] = prop === 'readonly' ? true : false;
  });
};

const handleCheckConditions = (field, operator, value) => {
  switch (operator) {
    case '==':
      return field == value;
    case '!=':
      return field != value;
    case '>':
      return field > value;
    case '>=':
      return field >= value;
    case '<':
      return field < value;
    case '<=':
      return field <= value;
    case 'in':
      return value.includes(field);
    case 'between':
      return field >= parseInt(value[0]) && field <= parseInt(value[1]);
    case 'like':
      return field === null
        ? false
        : field
            .toString()
            .toLowerCase()
            .includes(value.toString().toLowerCase())
        ? true
        : false;
    case 'not in':
      return !value.includes(field);
    case 'not between':
      return field <= parseInt(value[0]) || field >= parseInt(value[1]);
    case 'not like':
      return field === null
        ? true
        : !field
            .toString()
            .toLowerCase()
            .includes(value.toString().toLowerCase())
        ? true
        : false;
    default:
      return false;
  }
};

const setFieldStatus = (state, { page, mode, tab, step, type, fields }) => {
  let fieldsHideByGroup = [];
  fields.forEach(hide => {
    if (tab) {
      let element = state.schemes[page][mode].tabs.content[tab].fields.find(f => f.model === hide);

      if (element) {
        element[type.prop] = type.value;
      } else {
        let index = getGroupIndex(state.schemes[page][mode].tabs.content[tab].groups, hide);

        element = state.schemes[page][mode].tabs.content[tab].groups[index].fields.find(f => f.model === hide);

        element[type.prop] = type.value;
        type.prop === 'visible' && fieldsHideByGroup.push({ index, model: element.model });
      }
    } else if (step) {
      let element = state.schemes[page][mode].steps.content[step].fields.find(f => f.model === hide);

      if (element) {
        element[type.prop] = type.value;
      } else {
        let index = getGroupIndex(state.schemes[page][mode].steps.content[step].groups, hide);

        element = state.schemes[page][mode].steps.content[step].groups[index].fields.find(f => f.model === hide);

        element[type.prop] = type.value;
        type.prop === 'visible' && fieldsHideByGroup.push({ index, model: element.model });
      }
    } else {
      let element = state.schemes[page][mode].fields.find(f => f.model === hide);

      if (element) {
        element[type.prop] = type.value;
      } else {
        let index = getGroupIndex(state.schemes[page][mode].groups, hide);

        element = state.schemes[page][mode].groups[index].fields.find(f => f.model === hide);

        element[type.prop] = type.value;
        type.prop === 'visible' && fieldsHideByGroup.push({ index, model: element.model });
      }
    }
  });

  return fieldsHideByGroup;
};

export default {
  setPage: (state, { model, scheme }) => {
    state.models = { ...state.models, ...model };
    state.schemes = { ...state.schemes, ...scheme };
    sessionStorage.setItem('data', Encrypt(state.models, 'i4pro'));
  },

  updateSelectedItems: (state, payload) => {
    const { selectedItems, keyValue } = payload;

    state.selectedItems.keyValue = keyValue;
    state.selectedItems.items = selectedItems;
  },

  setMode: (state, { page, mode }) => {
    eventBus.$emit(HANDLERS.CHANGE_COMPONENT_IN_TAB, {
      page,
      context: mode
    });
    eventBus.$emit(HANDLERS.UPDATE_COMPONENT, {
      mode,
      page
    });

    state.schemes[page].default = mode;
  },

  setModel: (state, { page, data, masterContent, mode }) => {
    const type = masterContent ? 'master' : mode;

    if (!!state.models[page]) {
      state.models[page] = { ...state.models[page], ...{ [type]: data } };
    } else {
      state.models = { ...state.models, ...{ [page]: { [type]: data } } };
    }

    sessionStorage.setItem('data', Encrypt(state.models, 'i4pro'));

    if (masterContent && state.main == page) state.filter = data;
  },

  changePageMode: async (state, { page, mode }) => {
    state.schemes[page].default = mode;
    if (page !== state.main) {
      await sleep(50);
      eventBus.$emit(HANDLERS.CHANGE_COMPONENT_IN_TAB, { page, context: mode });
    }
  },

  setTabScheme: (state, payload) => {
    if (payload.page === 'dev') return;

    const conditions = state.schemes[payload.page][payload.mode].master.tabConditions;
    const tabs = state.schemes[payload.page][payload.mode].tabs.headers;
    const model = state.models[payload.page]['master'];

    tabs.forEach(element => {
      element.show = true;
      element.readonly = false;
    });

    conditions &&
      conditions.forEach(condition => {
        if (handleCheckConditions(payload.tab, condition.operator, condition.tab)) {
          if (condition.condition.length) {
            let execute = false;
            condition.condition.forEach(item => {
              if (handleCheckConditions(model[item.field], item.operator, item.value)) execute = true;

              if (execute) changeTabStatus(payload.tab, condition, tabs);
            });
          } else {
            changeTabStatus(payload.tab, condition, tabs);
          }
        }
      });
  },

  setStepScheme: (state, payload) => {
    if (payload.page === 'dev') return;

    const conditions = state.schemes[payload.page][payload.mode].steps.stepConditions;
    const steps = state.schemes[payload.page][payload.mode].steps.headers;
    const model = state.models[payload.page][payload.mode];

    steps.forEach(element => {
      element.show = true;
      element.readonly = false;
    });

    if (conditions) {
      conditions.forEach(condition => {
        if (handleCheckConditions(payload.step, condition.operator, condition.step)) {
          if (condition.condition.length) {
            let execute = false;
            condition.condition.forEach(item => {
              if (handleCheckConditions(model[item.field], item.operator, item.value)) execute = true;

              if (execute) changeStepStatus(payload.step, condition, steps);
            });
          } else {
            changeStepStatus(payload.step, condition, steps);
          }
        }
      });
    }
  },

  setLookupList: (state, payload) => {
    const { page, mode } = payload.info;
    const { name, items, model } = payload.data;

    if (!items.length) return;

    let key = state.schemes[page][mode].attributes.attributesTable.keyValue;

    state.schemes[page][mode].lookups[model[key]].find(x => x.model === name).attributesSelect.items = items;
  },

  setLookupListInit: (state, payload) => {
    const { page, items, key } = payload;

    for (let item of items) {
      if (item.typeLookup === 'normal') {
        let field = state.schemes[page]['list'].lookups[key].find(x => x.model === item.name);
        field.attributesSelect.items = item.items;
      }
    }
  },

  setLookupListScheme: (state, payload) => {
    const { page, mode } = payload.info;

    let key = state.schemes[page][mode].attributes.attributesTable.keyValue;

    for (let item of state.models[page][mode]) {
      state.schemes[page][mode].lookups = {
        ...state.schemes[page][mode].lookups,
        [item[key]]: JSON.parse(JSON.stringify(state.schemes[page][mode].fields))
      };
    }
  },

  setActionsCondition: (state, payload) => {
    let key = state.schemes[payload].list.attributes.attributesTable.keyValue;

    for (let item of state.models[payload].list) {
      state.schemes[payload].list.recordActions = {
        ...state.schemes[payload].list.recordActions,
        [item[key]]: JSON.parse(JSON.stringify(state.schemes[payload].list.recordActionsModel))
      };
    }
  },

  initConditionsList: (state, { page, mode, items, key }) => {
    if (!state.schemes[page][mode].conditions) return;

    const newItems = items.map(item => state.models[page][mode].find(x => x[key] === item[key]));
    conditionsList(state, { page, mode, items: newItems });
  },

  initInlineConditionsList: (state, { page, mode, items }) => {
    if (!state.schemes[page][mode].inlineConditions.length) return;
    if (!Object.entries(state.schemes[page][mode].lookups).length) return;

    const key = state.schemes[page][mode].attributes.attributesTable.keyValue;
    const models = state.models[page][mode];
    const records = items.map(item => item[key]);

    records.forEach(value => {
      let hide;
      let hideFields = [];
      let readonlyFields = [];
      let hideActions = [];

      state.schemes[page][mode].inlineConditions.forEach(condition => {
        var fieldsCheckConditions = true;

        condition.fields.forEach(item => {
          hide = handleCheckConditions(models.find(x => x[key] === value)[item.field], item.operator, item.value);

          if (!hide) fieldsCheckConditions = false;
        });

        if (hide && fieldsCheckConditions) {
          hideFields = [...hideFields, ...condition.hide.fields];
          hideActions = [...hideActions, ...condition.hide.actions];
          readonlyFields = [...readonlyFields, ...condition.readonly.fields];
        }
      });

      for (const field of state.schemes[page][mode].lookups[value]) {
        field.visible = true;
        field.readonly = false;
      }

      hideFields.forEach(hide => {
        let field = state.schemes[page][mode].lookups[value].find(f => f.model === hide);

        field.visible = false;

        const hideColumn = items.reduce((all, item) => {
          if (state.schemes[page][mode].lookups[item[key]].find(f => f.model === hide).visible) all = false;
          return all;
        }, true);

        if (hideColumn) {
          let colunm = state.schemes[page][mode].headers.find(x => x.value === hide);
          colunm.visible = false;
        }
      });

      readonlyFields.forEach(hide => {
        let field = state.schemes[page][mode].lookups[value].find(f => f.model === hide);
        field.visible = false;
      });
      for (let field of state.schemes[page].list.recordActions[value]) field.visible = true;
      hideActions.forEach(action => {
        let btn = state.schemes[page].list.recordActions[value].find(x => x.name === action);
        btn.visible = false;
      });
    });
  },

  setInlineConditionsList: (state, { page, mode, item, items }) => {
    const key = state.schemes[page][mode].attributes.attributesTable.keyValue;
    const value = item[key];

    let conditions = state.schemes[page][mode].inlineConditions;
    let model = state.models[page][mode];

    if (!conditions) return;

    let hide;
    let hideFields = [];
    let readonlyFields = [];
    let hideActions = [];

    conditions.forEach(condition => {
      var fieldsCheckConditions = true;

      condition.fields.forEach(item => {
        hide = handleCheckConditions(model.find(x => x[key] === value)[item.field], item.operator, item.value);
        if (!hide) fieldsCheckConditions = false;
      });

      if (hide && fieldsCheckConditions) {
        hideFields = [...hideFields, ...condition.hide.fields];
        hideActions = [...hideActions, ...condition.hide.actions];
        readonlyFields = [...readonlyFields, ...condition.readonly.fields];
      }
    });

    for (const field of state.schemes[page][mode].lookups[value]) {
      field.visible = true;
      field.readonly = false;
    }
    for (let header of state.schemes[page][mode].headers) header.visible = true;

    hideFields.forEach(hide => {
      let field = state.schemes[page][mode].lookups[value].find(f => f.model === hide);

      field.visible = false;

      const hideColumn = items.reduce((all, item) => {
        if (state.schemes[page][mode].lookups[item[key]].find(f => f.model === hide).visible) all = false;
        return all;
      }, true);

      if (hideColumn) {
        let colunm = state.schemes[page][mode].headers.find(x => x.value === hide);
        colunm.visible = false;
      }
    });

    readonlyFields.forEach(hide => {
      let field = state.schemes[page][mode].lookups[value].find(f => f.model === hide);
      field.visible = false;
    });

    for (let field of state.schemes[page].list.recordActions[value]) field.visible = true;
    hideActions.forEach(action => {
      let btn = state.schemes[page].list.recordActions[value].find(x => x.name === action);
      btn.visible = false;
    });
  },

  setConditions: async (state, { page, mode, tab, step }) => {
    let conditions;
    const model = state.models[page][mode];
    let fieldsHideByGroup = [];

    if (tab) {
      conditions = state.schemes[page][mode].tabs.content[tab].conditions;
    } else if (step) {
      conditions = state.schemes[page][mode].steps.content[step].conditions;
    } else {
      conditions = state.schemes[page][mode].conditions;
    }

    if (!conditions) return;

    let hide;
    let hideFields = [];
    let readonlyFields = [];
    let hideActions = [];

    conditions.forEach(condition => {
      var fieldsCheckConditions = true;

      condition.fields.forEach(item => {
        hide = handleCheckConditions(model[item.field], item.operator, item.value);

        if (!hide) fieldsCheckConditions = false;
      });

      if (hide && fieldsCheckConditions) {
        hideFields = [...hideFields, ...condition.hide.fields];
        hideActions = [...hideActions, ...condition.hide.actions];
        readonlyFields = [...readonlyFields, ...condition.readonly.fields];
      }
    });

    setReadonlyFields(state, { page, mode, tab, step, readonlyFields });

    if (tab) {
      for (let field of state.schemes[page][mode].tabs.content[tab].fields) {
        if ('hidden' in field) field.visible = false;
        else field.visible = true;
      }
      const { groups } = state.schemes[page][mode].tabs.content[tab];

      groups.forEach(group =>
        group.fields.forEach(field => {
          if ('hidden' in field) field.visible = false;
          else field.visible = true;
        })
      );
    } else if (step) {
      for (let field of state.schemes[page][mode].steps.content[step].fields) {
        if ('hidden' in field) field.visible = false;
        else field.visible = true;
      }

      const { groups } = state.schemes[page][mode].steps.content[step];

      groups.forEach(group =>
        group.fields.forEach(field => {
          if ('hidden' in field) field.visible = false;
          else field.visible = true;
        })
      );
    } else {
      for (let field of state.schemes[page][mode].fields) {
        if ('hidden' in field) field.visible = false;
        else field.visible = true;
      }

      const { groups } = state.schemes[page][mode];
      groups.forEach(group =>
        group.fields.forEach(field => {
          if ('hidden' in field) field.visible = false;
          else field.visible = true;
        })
      );
    }

    fieldsHideByGroup = setFieldStatus(state, { page, mode, tab, step, type: { prop: 'visible', value: false }, fields: hideFields });

    setFieldStatus(state, { page, mode, tab, step, type: { prop: 'readonly', value: true }, fields: readonlyFields });

    await sleep(200);
    eventBus.$emit(HANDLERS.SHOW_ACTIONS, { mode, page });
    eventBus.$emit(HANDLERS.SHOW_GROUPS, { page, mode, tab, step });
    fieldsHideByGroup = Object.values(fieldsHideByGroup.reduce((acc, cur) => Object.assign(acc, { [cur.model]: cur }), {}));

    let occurrences = {};
    fieldsHideByGroup.forEach(number => (occurrences[number.index] = (occurrences[number.index] || 0) + 1));

    for (const group in occurrences) {
      let fields = [];

      if (tab) {
        fields = state.schemes[page][mode].tabs.content[tab].groups[group].fields;
      } else if (step) {
        fields = state.schemes[page][mode].steps.content[step].fields[group].fields;
      } else {
        fields = state.schemes[page][mode].groups[group].fields;
      }

      if (fields.filter(x => x.type !== 'i4proGroupButtons').length === occurrences[group]) {
        eventBus.$emit(HANDLERS.HIDE_GROUP, { page, mode, tab, step, group });
      }
    }

    hideActions.forEach(action => eventBus.$emit(HANDLERS.HIDE_ACTION, { action, mode: mode, page }));
  },

  clear: state => {
    for (let item in state.schemes) {
      if (item != 'footer') {
        delete state.schemes[item];
        delete state.models[item];
      }
    }

    state.entries = {};
    state.parents = {};
  },

  updateModel: (state, { page, mode, model }) => {
    state.models[page][mode] = model;

    sessionStorage.setItem('data', Encrypt(state.models, 'i4pro'));
  },

  updateModelList: (state, { page, mode, model }) => {
    let param = state.schemes[page][mode].attributes.attributesTable.keyValue;

    const index = state.models[page][mode].findIndex(x => x[param] === model[param]);

    state.models[page][mode][index] = model;

    sessionStorage.setItem('data', Encrypt(state.models, 'i4pro'));
  },

  hideGroup: (state, { page, mode, tab, step, group }) => {
    let groups;

    if (tab) {
      groups = state.schemes[page][mode].tabs.content[tab].groups;
    } else if (step) {
      groups = state.schemes[page][mode].steps.content[step].groups;
    } else {
      groups = state.schemes[page][mode].groups;
    }

    groups[group].visible = false;
  },

  showGroups: (state, { page, mode, tab, step }) => {
    let groups;

    if (tab) {
      groups = state.schemes[page][mode].tabs.content[tab].groups;
    } else if (step) {
      groups = state.schemes[page][mode].steps.content[step].groups;
    } else {
      groups = state.schemes[page][mode].groups;
    }

    for (let group of groups) {
      group.visible = true;
    }
  },

  setLookup: (state, payload) => new Lookup(payload, state, getGroupIndex),

  setMain: (state, payload) => (state.main = payload),

  setScheme: (state, scheme) => (state.schemes = { ...state.schemes, ...scheme }),

  setParent: (state, { page, parent }) => (state.parents = { ...state.parents, [page]: parent }),

  setEntry: (state, { entry, page }) => (state.entries = { ...state.entries, ...{ [page]: entry } }),

  setInitialScheme: (state, scheme) => (state.initialSchemes = { ...state.initialSchemes, ...scheme }),

  clearFilter: state => (state.filter = {})
};
